var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfqSendTableWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Info Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Info Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9C1.5 4.86075 4.86 1.5 9 1.5C13.1475 1.5 16.5 4.86075 16.5 9C16.5 13.1407 13.1475 16.5 9 16.5C4.86 16.5 1.5 13.1407 1.5 9ZM8.34 6.1575C8.34 5.79825 8.64 5.4975 9 5.4975C9.36 5.4975 9.6525 5.79825 9.6525 6.1575V9.4725C9.6525 9.83325 9.36 10.125 9 10.125C8.64 10.125 8.34 9.83325 8.34 9.4725V6.1575ZM9.0075 12.5107C8.64 12.5107 8.3475 12.2107 8.3475 11.8507C8.3475 11.4907 8.64 11.1982 9 11.1982C9.3675 11.1982 9.66 11.4907 9.66 11.8507C9.66 12.2107 9.3675 12.5107 9.0075 12.5107Z",
    fill: "#F38D33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqSendTableWarning);
export default __webpack_public_path__ + "static/media/rfq-send-table-warning.ffa542a8ac480dc1323f4ed2ace6c93c.svg";
export { ForwardRef as ReactComponent };